export default "__VITE_ASSET__BRRyyDqv__"